import { render, staticRenderFns } from "./quickOpenDoc copy.vue?vue&type=template&id=847cb4f2&"
import script from "./quickOpenDoc copy.vue?vue&type=script&lang=js&"
export * from "./quickOpenDoc copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports